import styled from "styled-components";

export const ContentInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
  padding: 10px;
`;

export const ContentButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-top: 22px;

  button {
    transition: background-color 0.2s ease, box-shadow 0.2s ease,
      transform 0.2s ease, filter 0.2s ease;
  }

  button:hover:not(:disabled) {
    filter: brightness(0.9);
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
  }
`;